import FW from '../fw/fw';


export default class Speed {

  #rmp;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  #attachRates(index, event) {
    FW.eventStopPrevent(event);
    const speeds = this.#rmp.dom.speedOverlayLevelsArea.querySelectorAll('.rmp-overlay-level');
    if (speeds.length > 0 && speeds[index]) {
      const newSpeed = speeds[index];
      let rateText = newSpeed.textContent;
      if (typeof rateText === 'string' && rateText !== '') {
        rateText = parseFloat(rateText.replace('x', ''));
        this.#rmp.playbackRate = rateText;
        for (let i = 0, len = speeds.length; i < len; i++) {
          speeds[i].classList.remove('rmp-overlay-level-active');
        }
        newSpeed.classList.add('rmp-overlay-level-active');
      }
      this.#rmp.rmpUIManagement.showChrome();
    }
  }

  init() {
    this.#rmp.rmpModuleManagement.appendToModuleBar('speed');
    this.#rmp.rmpModuleManagement.appendOverlay('speed');
    this.#rmp.speedRates.forEach((speedRate, index) => {
      let className;
      if (speedRate === 1) {
        className = 'rmp-button rmp-overlay-level rmp-color-bg rmp-overlay-level-active';
      } else {
        className = 'rmp-button rmp-overlay-level rmp-color-bg';
      }
      const speedDiv = FW.createElement(
        'button',
        className,
        'x' + speedRate,
        this.#rmp.rtl,
        true
      );
      this.#rmp.rmpAccessible.button(speedDiv, this.#rmp.labels.hint.speed + ' x' + speedRate, true);
      const attachRates = this.#attachRates.bind(this, index);
      FW.addEvents(['touchend', 'click'], speedDiv, attachRates);
      this.#rmp.dom.speedOverlayLevelsArea.appendChild(speedDiv);
    });
  }
  
}
